import {
  Component,
  EventEmitter,
  OnInit,
  Output,
  ChangeDetectorRef,
} from '@angular/core';
import { IUploadListaForm } from './modal-upload-lista-layout.model';
import { ToastrService } from 'ngx-toastr';
import { AppExportBase64 } from '../../../../services/exportBase64/exportBase64.service';
import { PermissionService } from '../../../../services/permission.service';
import { HttpService } from '../../../../services/common/http/common.http.service';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';
@Component({
  selector: 'app-modal-upload-lista-layout',
  templateUrl: './modal-upload-lista-layout.component.html',
  styleUrls: ['./modal-upload-lista-layout.component.scss'],
})
export class UploadListaLayoutComponent implements OnInit {
  @Output() inputClose = new EventEmitter<boolean>();
  visible: boolean = true;
  loader: boolean = false;

  constructor(
    private httpService: HttpService,
    private exportBase64Service: AppExportBase64,
    private toast: ToastrService,
    private permissionService: PermissionService,
    private changeDetectorRef: ChangeDetectorRef,
    private router: Router
  ) {}

  ngOnInit() {
    this.permissionService.getPermission();
    this.populateAnoOptions();
    this.visible = true;
    this.changeDetectorRef.detectChanges();
  }

  form: IUploadListaForm = {
    mes: 0,
    ano: 0,
  };

  mesOptions = [
    { name: 'Janeiro', value: 1 },
    { name: 'Fevereiro', value: 2 },
    { name: 'Março', value: 3 },
    { name: 'Abril', value: 4 },
    { name: 'Maio', value: 5 },
    { name: 'Junho', value: 6 },
    { name: 'Julho', value: 7 },
    { name: 'Agosto', value: 8 },
    { name: 'Setembro', value: 9 },
    { name: 'Outubro', value: 10 },
    { name: 'Novembro', value: 11 },
    { name: 'Dezembro', value: 12 },
  ];

  anoOptions: any[] = [];

  populateAnoOptions() {
    const startYear = 2024;
    const currentYear = new Date().getFullYear();
    for (let year = startYear; year <= currentYear; year++) {
      this.anoOptions.push({ name: year.toString(), value: year });
    }
  }

  uploadArquivo(field: any) {
    this.loader = true;
    const base64 = field.split(',')[1];
    let funcionarioLocal = JSON.parse(
      String(localStorage.getItem('Funcionario'))
    );

    const body = {
      TxBase64: base64,
      NuMes: this.form.mes,
      NuAno: this.form.ano,
      FuncionarioId: Number(funcionarioLocal.IdFuncionario),
    };

    this.httpService
      .usePost('UploadApontamentoHora', body, false, false)
      .add(() => {
        this.loader = false;
        Swal.fire({
          title: 'Sucesso',
          text: 'Uploado realizado com sucesso. A planilha será enviado ao seu e-mail, aguarde.',
          icon: 'success',
          confirmButtonText: 'Ok',
          confirmButtonColor: 'green',
        }).then((result) => {
          if (result.isConfirmed)
            this.router.navigate(['encarregado/apontamentos']);
        });

        this.inputClose.emit(true);
      });
  }

  validarForm() {
    if (!this.form.mes || !this.form.ano) {
      return false;
    }
    return true;
  }
}
